import { useSelector } from 'react-redux';

import type { RootState } from '../../../store';

export default function useTreatmentPlanLegacyLoading(): boolean {
  const { loading: clientLoading } = useSelector((state: RootState) => state.clients);
  const { loading: treatmentPlanLoading } = useSelector((state: RootState) => state.treatmentPlans);
  const { loading: recommendationLoading } = useSelector(
    (state: RootState) => state.treatmentRecommendations,
  );

  return clientLoading || treatmentPlanLoading || recommendationLoading;
}
